import customModal from "../customModal/customModal.vue";

export default{
    name:"DataSignalPopup",
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        heading: {
            type: String,
            default: "Data Signals",
        },
    },
    components: {
        customModal,
    },
    data(){
        return {
            defaultdate: "",
        };
    },
    methods: {
        closeModal() {
            this.$emit("closeModal");
        }
    },
};